import { IExpenseSend } from 'src/types/expense';
import { ExpenseFormData } from 'src/screens/General/screens/Expenses/components/ExpenseForm';
import { changeToZeroMomentDate } from '../timeHelpers';

const groupExpense = (dataForm: Partial<ExpenseFormData>): Partial<IExpenseSend> => {
    const { expenseDate, amount, providerDropDown, ...data } = dataForm;
    const dataSend: Partial<IExpenseSend> = { ...data };

    if (providerDropDown) {
        dataSend.provider = providerDropDown.value;
    }
    if (amount) {
        dataSend.amount = parseFloat(`${amount}`);
    }
    if (expenseDate) {
        dataSend.expenseDate = changeToZeroMomentDate(expenseDate);
    }

    return dataSend;
};
export { groupExpense };
